import {
  fetchUserEmailSignature,
  createUserEmailSignature,
  updateUserEmailSignature,
  deleteUserEmailSignature,
} from '../routines/userManagementRoutines';

const initialState = {
  emailSignature: {
    type: null,
    signatureContent: '',
    isSetDefault: false,
  },
  isLoading: false,
  isSuccess: false,
};

const emailSignatureReducer = (state = initialState, action) => {
  switch (action.type) {
    case fetchUserEmailSignature.TRIGGER:
    case createUserEmailSignature.TRIGGER:
    case updateUserEmailSignature.TRIGGER:
    case deleteUserEmailSignature.TRIGGER:
      return {
        ...state,
        isLoading: true,
      };
    case fetchUserEmailSignature.SUCCESS: {
      return {
        ...state,
        emailSignature: {
          ...action.payload.data,
          isSetDefault: !!action.payload.data.isSetDefault,
        },
        isSuccess: true,
        isLoading: false,
      };
    }
    case createUserEmailSignature.SUCCESS:
    case updateUserEmailSignature.SUCCESS: {
      return {
        ...state,
        emailSignature: {
          ...action.payload.response.data,
          isSetDefault: !!action.payload.response.data.isSetDefault,
        },
        displaySuccessMessage: true,
        isSuccess: true,
        isLoading: false,
      };
    }
    case deleteUserEmailSignature.SUCCESS:
      return {
        ...state,
        emailSignature: initialState,
        displaySuccessMessage: true,
        isSuccess: true,
        isLoading: false,
      };
    case fetchUserEmailSignature.FAILURE:
    case createUserEmailSignature.FAILURE:
    case updateUserEmailSignature.FAILURE:
    case deleteUserEmailSignature.FAILURE:
      return {
        ...state,
        isLoading: false,
        isSuccess: false,
      };
    default:
      return state;
  }
};

export default emailSignatureReducer;
